import { useTheme } from "next-themes";
import { useEffect } from "react";

// The theme comes from the app's own switch (enableSystem is off), not the OS, so a
// prefers-color-scheme pair of theme-color tags would contradict the page. The phone's status bar
// takes the colour the page is actually painted in instead.
export function ThemeColourSync() {
  const { resolvedTheme, forcedTheme } = useTheme();
  const shown = forcedTheme ?? resolvedTheme;
  useEffect(() => {
    if (!shown) return;
    const paint = () => {
      const meta = document.querySelector<HTMLMetaElement>('meta[name="theme-color"]');
      const colour = getComputedStyle(document.body).backgroundColor;
      if (meta && meta.content !== colour) meta.content = colour;
    };
    // The provider swaps the root class in its own effect, after this child's, and the router's
    // head re-renders its tags after hydration: repaint a frame later and whenever the tag changes.
    const frame = requestAnimationFrame(paint);
    const watcher = new MutationObserver(paint);
    watcher.observe(document.head, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ["content"],
    });
    return () => {
      cancelAnimationFrame(frame);
      watcher.disconnect();
    };
  }, [shown]);
  return null;
}
